import QuotationUpload from "./QuotationUpload";

export default QuotationUpload;



// WEBPACK FOOTER //
// ./src/components/QuotationUpload/index.js